import { render, staticRenderFns } from "./MirrorsRedirectors.vue?vue&type=template&id=6a468d2c&"
import script from "./MirrorsRedirectors.vue?vue&type=script&lang=js&"
export * from "./MirrorsRedirectors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports